import { useId, useRef } from "react";
import useDialog from "../hooks/useDialog";
import { CloseIcon } from "./Icons";
import ui from "./ui.module.css";

const Panel = ({ title, onClose, children }) => {
  const titleId = useId();
  const closeRef = useRef(null);
  useDialog(onClose, closeRef);

  return (
    <div className={ui.sheetBackdrop} onClick={onClose}>
      <div
        className={`${ui.sheet} ${ui.panel}`}
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        onClick={(event) => event.stopPropagation()}
      >
        <div className={ui.row}>
          <h2 id={titleId}>{title}</h2>
          <button
            ref={closeRef}
            type="button"
            className={ui.iconButton}
            onClick={onClose}
            aria-label="Close"
          >
            <CloseIcon />
          </button>
        </div>
        {children}
      </div>
    </div>
  );
};

export default Panel;
